import { render, staticRenderFns } from "./FIBAvatar.vue?vue&type=template&id=0c1169a8&scoped=true&"
import script from "./FIBAvatar.vue?vue&type=script&lang=js&"
export * from "./FIBAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1169a8",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
